import SlideOverView from 'core/src/views/modules/slide-over';
import template from 'text!core/src/templates/slideovers/activity-slide-over.mustache';

const ActivityFeedSlideOverView = SlideOverView.extend({
  template: template,

  templateData: function() {
    const url = window.location.protocol + '//' + window.location.host + '/notifications?via=notifications-dropdown';
    return { 'seeAllUrl': url };
  },
});

export default ActivityFeedSlideOverView;

